import React from 'react';
import { useState } from 'react';
// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Container,
  Row,
  Spinner,
} from 'reactstrap';
import { get, keys, map, find, toNumber } from 'lodash-es';
import CreateChargerModal from '../../components/Modals/CreateCharger';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ChargerDetails from './ChargerDetails';
import ChargerLocationModal from '../../components/Modals/ChargerLocationModal';
import { createUseStyles } from 'react-jss';
import ReactPaginate from 'react-paginate';
import {
  localDate,
  calculatePageOffset,
  getTotalNumOfPages,
} from '../../utils/misc';
import { CSVLink } from 'react-csv';
import ChargersList from 'components/Charger/ChargersList';
import { useGetPartneredChargers } from 'utils/queries/partnerQueries';

/* ----------------Styles-------------- */
const useStyles = createUseStyles({
  chargerLink: {
    color: '#317ffe',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  onlineStatus: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#28a745',
      color: 'white',
      boxShadow: 'none',
    },
    boxShadow: 'none',
  },
  offlineStatus: {
    backgroundColor: '#e61b1b',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#e61b1b',
      color: 'white',
      boxShadow: 'none',
    },
    boxShadow: 'none',
  },
  pageNum: {
    fontWeight: 'bold',
    paddingRight: '10px',
    paddingLeft: '10px',
    paddingTop: '6px',
  },
  activePageNum: {
    backgroundColor: '#2675b8',
    color: 'white',
    borderRadius: '5px',
  },
  pagination: {
    display: 'flex',
    listStyle: 'none',
    paddingLeft: '0px',
    justifyContent: 'flex-end',
  },
});

const Charger = () => {
  const classes = useStyles();
  const route = useRouteMatch();

  //Fetch chargers here
  // eslint-disable-next-line no-unused-vars
  const [chargersPageNum, setChargersPageNum] = useState(
    toNumber(localStorage.getItem('chargersPageNum')) || 1,
  );
  const limit = 1000;

  // const { data: chargers, isLoading } = useHostChargersList({
  //   limit,
  //   offset: calculatePageOffset(limit, chargersPageNum),
  //   page: chargersPageNum,
  // });

  const { data: chargers, isLoading } = useGetPartneredChargers();

  function generateChargersCsvData(chargers) {
    const formattedChargersData = map(chargers, (charger, c) => {
      const connector1 = find(get(charger, 'CONNECTORS'), {
        CONNECTOR_ID: 1,
      });

      const connector2 = find(get(charger, 'CONNECTORS'), {
        CONNECTOR_ID: 2,
      });

      const connector3 = find(get(charger, 'CONNECTORS'), {
        CONNECTOR_ID: 3,
      });

      const connector4 = find(get(charger, 'CONNECTORS'), {
        CONNECTOR_ID: 4,
      });

      const formattedCharger = {
        ID: get(charger, 'ID'),
        NAME: get(charger, 'NAME'),
        ADDRESS: get(charger, 'ADDRESS'),
        ZIPCODE: get(charger, 'ZIPCODE'),
        LATITUDE: get(charger, 'LATITUDE'),
        LONGITUDE: get(charger, 'LONGITUDE'),
        CHARGER_TYPE: get(charger, 'IS_DC') === 0 ? 'AC' : 'DC',
        // MODEL: get(charger, 'MODEL'),
        // VENDOR: get(charger, 'VENDOR'),
        ADDED_AT: `${localDate(get(charger, 'CREATED_AT'))}`,
        TARIFF: `₹ ${get(charger, 'BASE_KWH_COST')}`,
        CAPACITY: `${get(charger, 'ENERGY')} kW`,
        OPEN_TIMING: get(charger, 'TIMING'),
        VEHICLE_TYPE:
          get(charger, 'VEHICLE_TYPE') === '4'
            ? '4 Wheelers'
            : '2 + 3 Wheelers',
        'CONNECTOR 1': connector1?.TYPE,
        'CONNECTOR 2': connector2?.TYPE,
        'CONNECTOR 3': connector3?.TYPE,
        'CONNECTOR 4': connector4?.TYPE,
      };
      return formattedCharger;
    });

    const fields = {};

    map(keys(get(formattedChargersData, '[0]', {})), (item) => {
      fields[item] = item;
    });

    return {
      data: formattedChargersData,
      fields,
    };
  }

  //local states

  const [creatChargerModalOpen, setCreateChargerModalOpen] = useState(false);
  const toggleCreateChargerModal = () =>
    setCreateChargerModalOpen(!creatChargerModalOpen);
  const [chargerLocationModalOpen, setChargerLocationModalOpen] =
    useState(false);
  const toggleChargerLocationModal = () =>
    setChargerLocationModalOpen(!chargerLocationModalOpen);
  // const [selectedCharger, setSelectedCharger] = useState({});
  const selectedCharger = {};

  // function isChargerOnline(charger) {
  //   const { LAST_HEARTBEAT } = charger;
  //   let chargerConfig = {};
  //   if (get(charger, 'CHARGER_CONFIGURATION')) {
  //     chargerConfig = JSON.parse(get(charger, 'CHARGER_CONFIGURATION'));
  //   }

  //   const chargerHearBeatConfigObj = find(
  //     get(chargerConfig, 'configurationKey'),
  //     { key: 'HeartbeatInterval' },
  //   );
  //   const chargerHeartBeatInterval = toNumber(
  //     get(chargerHearBeatConfigObj, 'value'),
  //   );
  //   const diffInSeconds = differenceInSeconds(
  //     new Date(),
  //     new Date(LAST_HEARTBEAT),
  //   );
  //   return diffInSeconds <= chargerHeartBeatInterval;
  // }

  // Chart states
  // const [activeTab, setActiveTab] = useState('1');
  // const toggle = (tab) => {
  //   if (activeTab !== tab) setActiveTab(tab);
  // };
  // const [granularityKWHSold, setGranularityKWHSold] = useState('last_10_days');
  // const [granularityRevenue, setGranularityRevenue] = useState('last_10_days');
  // const [granularityTimeDuration, setGranularityTimeDuration] =
  //   useState('last_10_days');

  return (
    <>
      <Switch>
        <Route path={`${route.path}`} exact>
          <Container className="" style={{ marginTop: 100 }} fluid>
            {/* Table */}

            <Row>
              <div className="col">
                <Card className="shadow" style={{ minHeight: '400px' }}>
                  <CardHeader
                    className="border-0"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      paddingBottom: 0,
                    }}
                  >
                    <h3>
                      Chargers{' '}
                      <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                        (Host)
                      </span>
                      {isLoading ? (
                        <Spinner
                          style={{
                            color: '#2675b8',
                            fontSize: '8px',
                            height: '20px',
                            width: '20px',
                            marginLeft: '15px',
                          }}
                        />
                      ) : null}
                    </h3>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                      }}
                    >
                      <CSVLink
                        data={generateChargersCsvData(chargers).data}
                        filename={'Chargers.csv'}
                        style={{
                          backgroundColor: '#2675b8',
                          color: 'white',
                          border: '0px solid transparent',
                          paddingTop: '10px',
                          paddingBottom: '10px',
                          paddingLeft: '15px',
                          paddingRight: '15px',
                          borderRadius: '6px',
                          marginBottom: '0px',
                          height: '41px',
                          marginRight: '10px',
                          fontSize: '14px',
                          fontWeight: 600,
                        }}
                      >
                        Export as CSV
                      </CSVLink>

                      {/* <Button
                        style={{
                          backgroundColor: '#2675b8',
                          color: 'white',
                          border: '0px solid transparent',
                        }}
                        onClick={() => toggleCreateChargerModal()}
                      >
                        Add New Charger
                      </Button> */}
                    </div>
                  </CardHeader>
                  <hr style={{ margin: '5px' }} />
                  <ChargersList
                    data={{ list: chargers || [] }}
                    isLoading={isLoading}
                  />

                  <CardFooter className="py-4">
                    {chargers?.length > 0 &&
                    getTotalNumOfPages(
                      toNumber(localStorage.getItem('pageTotalHostChargers')),
                      limit,
                    ) > 1 ? (
                      <nav aria-label="...">
                        <ReactPaginate
                          previousLabel={
                            <div
                              style={{
                                border: '1px solid #e8ebee',
                                padding: '10px',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                marginRight: '10px',
                              }}
                              onClick={() => {
                                if (!chargersPageNum === 1) {
                                  setChargersPageNum(chargersPageNum - 1);
                                }
                              }}
                            >
                              <i
                                className="fas fa-angle-left"
                                style={{ color: '#94a3b3' }}
                              />
                            </div>
                          }
                          nextLabel={
                            <div
                              style={{
                                border: '1px solid #e8ebee',
                                padding: '10px',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                marginLeft: '10px',
                              }}
                              onClick={() => {
                                if (
                                  !(
                                    calculatePageOffset(
                                      limit,
                                      chargersPageNum,
                                    ) +
                                      limit >=
                                    (toNumber(
                                      localStorage.getItem(
                                        'pageTotalHostChargers',
                                      ),
                                    ) || 0)
                                  )
                                ) {
                                  setChargersPageNum(chargersPageNum + 1);
                                }
                              }}
                            >
                              <i
                                className="fas fa-angle-right"
                                style={{ color: '#94a3b3' }}
                              />
                            </div>
                          }
                          pageRangeDisplayed={2}
                          breakLabel={'...'}
                          breakClassName={'break-me'}
                          initialPage={chargersPageNum - 1}
                          pageCount={getTotalNumOfPages(
                            toNumber(
                              localStorage.getItem('pageTotalHostChargers'),
                            ),
                            limit,
                          )}
                          marginPagesDisplayed={2}
                          onPageChange={(data) => {
                            setChargersPageNum(data.selected + 1);
                          }}
                          disableInitialCallback={true}
                          containerClassName={classes.pagination}
                          pageClassName={classes.pageNum}
                          activeClassName={classes.activePageNum}
                        />
                      </nav>
                    ) : null}
                  </CardFooter>
                </Card>
              </div>
            </Row>
            <CreateChargerModal
              toggleModalOpen={toggleCreateChargerModal}
              modalOpen={creatChargerModalOpen}
            />
            <ChargerLocationModal
              toggleModalOpen={toggleChargerLocationModal}
              modalOpen={chargerLocationModalOpen}
              selectedCharger={selectedCharger}
            />
          </Container>
        </Route>
        <Route
          path={`${route.path}/:cpid`}
          render={({ match }) => <ChargerDetails />}
        />
      </Switch>
    </>
  );
};

export default Charger;
